import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import 'dayjs/locale/es';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.locale('es');

export const formatTimeAgo = (date, timezone = 'America/Lima') => {

  const dateObject = dayjs.utc(date).tz(timezone);
  const now = dayjs().tz(timezone);

  if (now.diff(dateObject, 'minute') < 60) {
    return dateObject.fromNow();
  } else if (now.isSame(dateObject, 'day')) {
    return dateObject.format('HH:mm A');
  } else if (now.diff(dateObject, 'day') < 2) {
    return dateObject.fromNow();
  } else {
    return dateObject.format('HH:mm DD/MM/YYYY');
  }
};
